module.exports = __webpack_public_path__ + "img/集团型实验室.60c98883.png";